/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useMemo } from "react";
import { useBooking } from "../../hooks/useBooking";
import { addMinutes, format } from "date-fns";
import DateTimeCard from "./DateTimeCard";
import {useServicesSummary} from "../../hooks/useServicesSummary";

const SelectedDateTimeCard = ({ canEdit, canDelete, recurringData, timeLabel }) => {
  const { selectedServices, selectedDate, selectedTime, setSelectedDate, setSelectedTime } = useBooking();
  const servicesSummary = useServicesSummary(selectedServices);

  const timeFrom = `${selectedDate} ${selectedTime}`;
  const timeTo = useMemo(() => {
    if (!selectedTime || !servicesSummary.duration) return null;
    const timeToDate = addMinutes(new Date(`${selectedDate}T${selectedTime}`), servicesSummary.duration);

    return `${selectedDate} ${format(timeToDate, "HH:mm:ss")}`;
  }, [selectedDate, selectedTime, servicesSummary.duration]);


  const handleDeleteTime = (e) => {
    e.stopPropagation();
    setSelectedDate(format(new Date(), "yyyy-MM-dd"));
    setSelectedTime(null);
  };

  return (
    <DateTimeCard
      canEdit={canEdit}
      canDelete={canDelete}
      date={selectedDate}
      timeFrom={timeFrom}
      timeTo={timeTo}
      timeLabel={timeLabel}
      recurringData={recurringData}
      onDelete={handleDeleteTime}
    />
  );
};

export default SelectedDateTimeCard;
